import { getDoamins } from '../../services/finance';
import { getProvinceData, getDomainData, enumerationData } from '../../services/home';
export default {
  namespace: 'financeDatabase',
  state: {
    doaminsList:[],
    provinces:{},
    domains:{},
    enumerationData:{}
  },
  subscriptions: {
    // setup({ dispatch, history }) {}
  },
  
  effects: {
    * linkageData(a, { call, put }) { 
      let provinceData = yield call(getProvinceData);
      let domainData = yield call(getDomainData);
      if(domainData.success){
        yield put({
          type: 'current',
          payload:{
            domains:domainData.data
          } 
        });
      }
      if(provinceData.success){
        yield put({
          type:'current',
          payload:{
            provinces:provinceData.data
          }
        });
      }
    },
    
    // 枚举数据
    * listStateData(a, { call, put }) { 
      let listState = yield call(enumerationData);
      if(listState.success){
        yield put({
          type: 'listState', 
          enumerationData:listState.data
        });
      }
    },
    
    *getDoamins(a,{call,put}){
      let data = yield call(getDoamins);
      if(data.success){
        yield put({
          type: 'current',
          payload: {
            doaminsList:data.data.domainListMap
          }
        });
      }
    }

  },
  
  reducers: {
    // 当前数据
    current(state, { payload }) {
      return {...state,...payload};
    },
    // 项目状态
    listState(state, { enumerationData }) {
      return {
        ...state,
        enumerationData:enumerationData
      };
    },
  }
    
};
  


// WEBPACK FOOTER //
// ./src/scripts/models/Finance/FinanceDatabase.js